import React, { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ButtonGroup, Button } from "react-bootstrap";
import { setSubLoadViewType } from "../../../actions/dashboard";

const SubViewToggle = () => {
  const dispatch = useDispatch();
  const viewId = useSelector((state) => state.dashboard.loads.viewId);
  const subViewId = useSelector((state) => state.dashboard.loads.subViewId);
  const viewTypes = useSelector((state) => state.dashboard.loads.viewTypes);
  const selectedPlanType = useSelector((state) => state.plan.selectedPlanType);

  const views = useMemo(() => {
    let views = viewTypes.filter((e) => e.keyName && e.id !== viewId);
    if (selectedPlanType === 2) {
      views = views.filter((e) => e.id !== 4);
    }
    return views;
  }, [viewTypes, selectedPlanType]);

  return (
    <ButtonGroup toggle={true} className="btn-grp">
      {views.map((item) => {
        return (
          <Button key={item.id} variant={item.id === parseInt(subViewId) ? "primary" : "default"} onClick={() => dispatch(setSubLoadViewType(item.id))} eventkey={item.id} className="btn-type">
            {item.name}
          </Button>
        );
      })}
    </ButtonGroup>
  );
};

export default SubViewToggle;
